import { toEmbedUrl, isDirectVideo } from "@/lib/video";

type Props = {
  value: string[];
  onChange: (next: string[]) => void;
  max?: number;
};

const VideoUrlList = ({ value, onChange, max = 3 }: Props) => {
  const update = (i: number, v: string) => {
    const next = [...value];
    next[i] = v;
    onChange(next);
  };
  const remove = (i: number) => onChange(value.filter((_, idx) => idx !== i));
  const add = () => {
    if (value.length >= max) return;
    onChange([...value, ""]);
  };

  return (
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground">
        Paste YouTube, Vimeo, or direct .mp4 URLs. Max {max}.
      </p>
      {value.map((url, i) => {
        const valid = !url || !!toEmbedUrl(url) || isDirectVideo(url);
        return (
          <div key={i} className="flex gap-2 items-start">
            <div className="flex-1">
              <input
                value={url}
                onChange={(e) => update(i, e.target.value)}
                placeholder="https://www.youtube.com/watch?v=…"
                className="w-full px-3 py-2 rounded-xl bg-muted border border-border focus:outline-none focus:ring-2 focus:ring-primary text-sm"
              />
              {!valid && (
                <p className="text-xs text-destructive mt-1">
                  Unsupported URL — use YouTube, Vimeo, or a direct video file.
                </p>
              )}
            </div>
            <button type="button" onClick={() => remove(i)} className="px-3 py-2 text-destructive">
              ✕
            </button>
          </div>
        );
      })}
      {value.length < max && (
        <button type="button" onClick={add} className="text-sm text-primary font-semibold">
          + Add video
        </button>
      )}
    </div>
  );
};

export default VideoUrlList;
